import { ROLE_CHALLENGE_MULTIPLIERS, SERVICE_TEAM_MAP } from './calculatorConstants';

export const DEFAULT_TEAM_COMPOSITION: Record<string, number> = {
    projectManager: 1,
    designer: 0,
    developer: 0,
    tester: 0.5,
    backendDev: 0,
    devops: 0,
    mlEngineer: 0,
    consultant: 0,
};

export const buildInitialTeamForChallenge = (
    previousTeam: Record<string, number>,
    challenge: string
): Record<string, number> => {
    const challengeMultipliers = ROLE_CHALLENGE_MULTIPLIERS[challenge] || {};

    return Object.keys(previousTeam).reduce((acc, key) => {
        if (key === 'projectManager' || key === 'tester') {
            acc[key] = challengeMultipliers[key] || 0;
        } else if (key === 'developer' && ROLE_CHALLENGE_MULTIPLIERS[challenge]) {
            const dev1 = challengeMultipliers.developer || 0;
            const dev2 = challengeMultipliers.developer2 || 0;
            acc[key] = dev1 + dev2;
            acc['developer2'] = 0;
        } else {
            acc[key] = 0;
        }
        return acc;
    }, {} as Record<string, number>);
};

export const applyServicesToTeam = (
    baseTeam: Record<string, number>,
    services: string[],
    challenge: string
): Record<string, number> => {
    if (!challenge || services.length === 0) {
        return baseTeam;
    }

    const multipliers = ROLE_CHALLENGE_MULTIPLIERS[challenge] || {};
    const newTeam = { ...baseTeam };

    const serviceTeamMembers: Record<string, number> = {};

    services.forEach((service) => {
        if (SERVICE_TEAM_MAP[service]) {
            Object.entries(SERVICE_TEAM_MAP[service].members).forEach(([role, details]) => {
                if (role === 'projectManager' || role === 'tester') return;
                serviceTeamMembers[role] = (serviceTeamMembers[role] || 0) + details.quantity;
            });
        }
    });

    Object.entries(serviceTeamMembers).forEach(([role, quantity]) => {
        if (quantity > 0) {
            const roleMultiplier = multipliers[role] || 1;
            newTeam[role] = quantity * roleMultiplier;
        }
    });

    return newTeam;
};
